export const environment = {
  production: false,
  // apiUrl: 'http://18.237.27.226:8081/api/v1.0', //pruebas
  // apiUrl: 'https://gbi.hachettelivre.mx:8083/api/v1.0', // pruebas final
  apiUrl: 'https://gbi.hachettelivre.mx:8080/api/v1.0',
  // apiUrl: 'https://devgbi.hachettelivre.mx:8080/api/v1.0',
  // apiUrl: 'https://devgbi.hachettelivre.mx:8081/api/v1.0',
  // apiUrl: 'http://localhost:53517/v1.0',
  apiKey: 'ce186f354cff5e3d378259fc6e944c1f5b4031ab631b1dd25be55bf0d4d19b07',
};
